export const UserEligibilityKeys = {
    isBMIValueEligible: 'isBMIValueEligible',
    userStatus: {
        approved: 'Approved',
        needsReview: 'Needs to be reviewed'
    }
};
